import useTypingEffect from "./TypingEffect";

const LiveText = ({
  textIndex,
  textInput,
  setTempTextIndex,
  displayInput,
  checkDisplayInput,
}) => {
  const duration = 10;
  const isTypeByLetter = true;
  const textToShow = useTypingEffect(textInput, duration, isTypeByLetter);
  if (textToShow === textInput && !displayInput) {
    setTimeout(() => {
      setTempTextIndex((prevIndex) => {
        return prevIndex === textIndex ? prevIndex + 1 : prevIndex;
      });
      checkDisplayInput();
    }, 500);
  }
  return <span className="dss-search-texting">{textToShow}</span>;
};

export default LiveText;
